module.exports = __webpack_public_path__ + "img/Lotfreeze.c9a0d3f4.png";